<!--
//================================================================================
// ID:BC059P
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC059P
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/11/15 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/06/07 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.02.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.03.00 | 2024/09/20 | 富士通Japan株式会社    | 令和6年度改修対応（1次リリース）
//================================================================================
-->
<template>
	<main class="contents__main">
		<div>
			<transition :name="fade" mode="out-in">
				<!-- viewPageの値に応じてコンポーネントを切り替え -->
				<component
					:is="viewPage"
					:form="form"
					:sourceInfo="sourceInfo"
					@back="back"
				>
				</component>
			</transition>
		</div>
	</main>
</template>

<script>
import BC059Page1 from './BC059C1.vue'
import BC059Page2 from './BC059C2.vue'
import BC059Page3 from './BC059C3.vue'

import { STORE_VIEW_PROGRESS, STORE_VIEW_TITLE, STORE_DATA_GETDATA, STORE_DATA_DELETE_AT, STORE_VIEW_GET_PARAMS } from '@/const/store.js';
import { co_clearParam, co_toTransCtrl } from '@/common/screenUtility.js';

export default {
	data: function () {
		return {
			form: {
				zyutakuInfo: [],		// 住宅情報
				kbBosyu: '',			// 募集の種類
				ymBosyu: '',			// 募集年月
				noRenzoku: '',			// 連番
				noUketuke: '',			// 受付番号
				dtSyokaiMosikomi: '',	// 初回申込日
				dtMosikomi: '',			// 申込日
				nmBosyu: '',			// 募集の種類名
				kbZyutaku: '',			// 住宅の種別
				nmZyutaku: '',			// 住宅の種別名
				kbKoubo: '',			// 公募区分
				noMouchiku: '',			// 申込地区番号
				nuDoukyo: '',			// 同居人数
				nuNyukyo: '',			// 入居人数
				kbMosikomi: '',			// 申込区分
				nmMosikomi: '',			// 申込区分名
				cdYugu: '',				// 優遇コード
				nmYugu: '',				// 優遇コード名
				idRiyosya: '',			// 利用者番号
				nmMouname1: '',			// 申込者（氏）
				nmMouname2: '',			// 申込者（名）
				nmMoukana1: '',			// 申込者フリガナ（氏）
				nmMoukana2: '',			// 申込者フリガナ（名）
				nmMoutusyoname1: '',	// 申込者通称名（氏）
				nmMoutusyoname2: '',	// 申込者通称名（名）
				nmMoutusyokana1: '',	// 申込者通称名フリガナ（氏）
				nmMoutusyokana2: '',	// 申込者通称名フリガナ（名）
				dtMoubirthday: '',		// 申込者生年月日
				noMouzip1: '',			// 申込者郵便番号１
				noMouzip2: '',			// 申込者郵便番号２
				txMouadr1: '',			// 申込者現住所１
				txMouadr2: '',			// 申込者現住所２
				txMouadr3: '',			// 申込者現住所３
				idMoutel1: '',			// 申込者電話番号（市外）
				idMoutel2: '',			// 申込者電話番号（市内）
				idMoutel3: '',			// 申込者電話番号（局番）
				nuKyojyu: '',			// 申込者居住年数
				kbZairyusikaku: '',		// 申込者在留資格
				dtZairyuStt: '',		// 申込者在留期間（自）
				dtZairyuEnd: '',		// 申込者在留期間（至）
				moAllsyotoku: '',		// 年間所得金額合計
				moAlltokubetu: '',		// 特別控除金額
				moAllsasihiki: '',		// 差引所得金額
				nmGaifuyoList: [],		// 入居外扶養親族リスト
				cdNowjyutaku: '',		// 現在の住宅の種類
				moNowyachin: '',		// 現在の住宅の家賃
				cdNowmadori: '',		// 現在の住宅の間取り
				nuNowtatamisu: '',		// 現在の住宅の畳数
				nuNowsenyo: '',			// 現在の住戸専用面積
				kbKaidan: '',			// 階段困難区分
				fgTokubetu: '',			// 特別区分
				kbShinshin1: '',		// 心身障害者該当項目１
				kbShinshin2: '',		// 心身障害者該当項目２
				kbShinshin3: '',		// 心身障害者該当項目３
				kbShinshin4: '',		// 心身障害者該当項目４
				kbSyoyu: '',			// 住宅土地所有区分
				fgSeiyakuDoui: '',		// 誓約・同意の有無
				cdStatus: '',			// 状況
				txOstype: '',			// OSの種類
				txOsversion: '',		// OSのバージョン
				txBrowsertype: '',		// ブラウザの種類
				txAnketo1: '',			// アンケート表題１
				kbAnketo1: '',			// アンケート回答１
				txAnketo1ansetc: '',	// アンケート回答１その他
				txAnketo2: '',			// アンケート表題２
				kbAnketo2: '',			// アンケート回答２
				txAnketo2ansetc: '',	// アンケート回答２その他
				txAnketo3: '',			// アンケート表題３
				kbAnketo3: '',			// アンケート回答３
				txAnketo3ansetc: '',	// アンケート回答３その他
				txAnketo4: '',			// アンケート表題４
				txAnketo4ans: '',		// アンケート回答４
				nyukyoList: [],			// 入居者情報リスト
				mouItems1cdHanyo2: '',	// 申込区分注意文１汎用コード２
				transKbn: '',			// 遷移区分
				fuyoList: [],			// 遠隔地扶養者情報リスト
				txKiboJyoken: '',		// ご希望の住宅の条件
				txBekkyozyokyo: '',		// 別居状況内容
				kbBekkyoyotei: '',		// 別居予定者有無
				nmBekkyoyotei: '',		// 別居予定者有無名
				bosyuHoshiki: '4',		// 募集方式（1：毎月募集、2：定期募集（抽選方式）、3：定期募集（ポイント方式）、4：随時募集）
				moSyotoku: '',			// 申込者年間所得金額
				fgKojto: '',			// 申込者特別控除
				txSyozaichi: '',		// 申込者所在地
				txName: '',				// 申込者名称
				idTel1: '',				// 申込者電話番号（市外）
				idTel2: '',				// 申込者電話番号（市内）
				idTel3: '',				// 申込者電話番号（局番）
				dtYmdStt: '',			// 申込者勤務（開業）開始日
				cdSyokugyo: '',			// 申込者職業
			},
			sourceInfo: {
				selectNo: 0,			// 選択行No
				transKbn: '',			// 遷移区分（サブ画面用）
			},
			mosikomiInfo: [],			// 申込情報
			transKbn: '',				// 遷移区分
			kbBosyu: '',				// 募集の種類
			kbZyutaku: '',				// 住宅の種別
			ymBosyu: '',				// 募集年月
			noMouchiku: '',				// 申込地区番号
			noRenzoku: '',				// 連番
			noUketuke: '',				// 受付番号
		}
	},
	created: async function() {

		// 画面タイトル
		this.$store.commit(STORE_VIEW_TITLE, '世帯情報入力の確認（随時募集・管理者用【代理申込み】）');

		// 前画面からのパラメータを設定
		let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC059');
		this.mosikomiInfo = params.mosikomiInfo;
		this.transKbn = params.transKbn;
		this.kbBosyu = params.kbBosyu;
		this.kbZyutaku = params.kbZyutaku;
		this.ymBosyu = params.ymBosyu;
		this.noMouchiku = params.noMouchiku;
		this.noRenzoku = params.noRenzoku;
		this.noUketuke = params.noUketuke;

		// 画面間パラメータを削除
		co_clearParam('BC059');

		// パラメタ設定
		if (this.mosikomiInfo != null) {
			this.form = this.mosikomiInfo;
			this.form.kbShinGaitokomoku1 = '';
			if (this.mosikomiInfo.kbShinGaitokomoku.indexOf('1') != -1) {
				this.form.kbShinGaitokomoku1 = '1';
			}
			this.form.kbShinGaitokomoku2 = '';
			if (this.mosikomiInfo.kbShinGaitokomoku.indexOf('2') != -1) {
				this.form.kbShinGaitokomoku2 = '2';
			}
			this.form.kbShinGaitokomoku3 = '';
			if (this.mosikomiInfo.kbShinGaitokomoku.indexOf('3') != -1) {
				this.form.kbShinGaitokomoku3 = '3';
			}
			this.form.kbShinGaitokomoku4 = '';
			if (this.mosikomiInfo.kbShinGaitokomoku.indexOf('4') != -1) {
				this.form.kbShinGaitokomoku4 = '4';
			}
		} else {
			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let saveData = this.$store.getters[STORE_DATA_GETDATA]('BC059');
			this.form = saveData;
			this.form.noRenzoku = this.noRenzoku;

			// 画面の状態管理情報を削除
			this.$store.commit(STORE_DATA_DELETE_AT, 'BC059');
		}
		
	},
	computed: {
		viewPage () {
			// URLのhashの値に基づいて、返すコンポーネントを切り替え
			switch (this.$route.hash) {
				case '#BC059C2':
					return BC059Page2
				case '#BC059C3':
					return BC059Page3
				default:
					return BC059Page1
			}
		}
	},
	methods: {
		
		// サブ画面から世帯情報入力の確認画面へ遷移
		back: function(select) {
			this.transitionName = 'slide-back'
			this.sourceInfo.selectNo = select - 1;
			switch (this.$route.hash) {
				case '#BC059C2':
					this.sourceInfo.transKbn = '2';
					this.$router.push({ hash: '#BC059C1' })
					break;
				case '#BC059C3':
					this.sourceInfo.transKbn = '3';
					this.$router.push({ hash: '#BC059C1' })
					break;
			}
			co_toTransCtrl();
		}
	}
}
</script>